/**
 * Reverb - Réverbération avec contrôles
 */

import * as Tone from 'tone';

export class Reverb {
    constructor(audioEngine) {
        this.audioEngine = audioEngine;

        // Paramètres par défaut
        this.params = {
            decay: 2.5,       // Temps de réverb en secondes
            preDelay: 0.01,   // Pré-délai
            mix: 0.3          // Dry/Wet 0-1
        };

        this.setupAudio();
    }

    setupAudio() {
        // Reverb Tone.js
        this.reverb = new Tone.Reverb({
            decay: this.params.decay,
            preDelay: this.params.preDelay,
            wet: this.params.mix
        });

        // Générer l'impulse response
        this.reverb.generate();

        // Input/Output nodes
        this.input = this.reverb;
        this.output = this.reverb;
    }

    /**
     * Connecte la sortie du reverb à une destination
     */
    connectTo(destination) {
        this.output.connect(destination);
    }

    /**
     * Déconnecte la sortie
     */
    disconnect() {
        this.output.disconnect();
    }

    /**
     * Active/désactive l'effet (pour compatibilité avec auto-bypass)
     * @param {boolean} active - true pour activer, false pour désactiver
     */
    setActive(active) {
        // La reverb n'a pas de LFO, on ajuste le mix
        this.reverb.wet.value = active ? this.params.mix : 0;
    }

    // --- Setters ---

    setDecay(value) {
        this.params.decay = value;
        this.reverb.decay = value;
    }

    setPreDelay(value) {
        this.params.preDelay = value;
        this.reverb.preDelay = value;
    }

    setMix(value) {
        this.params.mix = value;
        this.reverb.wet.value = value;
    }

    // --- Getters ---

    get decay() { return this.params.decay; }
    get preDelay() { return this.params.preDelay; }
    get mix() { return this.params.mix; }

    /**
     * Retourne tous les paramètres (pour sauvegarde)
     */
    getParams() {
        return { ...this.params };
    }

    /**
     * Charge des paramètres (depuis sauvegarde)
     */
    setParams(params) {
        if (params.decay !== undefined) this.setDecay(params.decay);
        if (params.preDelay !== undefined) this.setPreDelay(params.preDelay);
        if (params.mix !== undefined) this.setMix(params.mix);
    }
}
